import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { selectors } from '@yola/subscription-manager-js';
import routesMap from '../../../router/helpers/routes-map';
import supportedTabs from '../constants/supported-tabs';
import SubscriptionDetailsPage from '../pages/subscription-details-page';

const SubscriptionDetailsRoute = () => {
  const { subId } = useParams();
  const navigate = useNavigate();

  const subscription = useSelector(
    (state) => selectors.getActiveSubscriptionById(state, subId),
    shallowEqual
  );

  if (!subscription) {
    navigate(routesMap.accountManagement.url({ tabId: supportedTabs.SUBSCRIPTIONS }));
    return null;
  }

  return <SubscriptionDetailsPage subscription={subscription} />;
};

export default SubscriptionDetailsRoute;
